import {CSSTransition, TransitionGroup} from "react-transition-group";
import ChatDropZone from "../../../dropzone/part-support-request-chat";
import React from "react";
import {sendChatFiles} from "../../../../../../core/services/utils/utils";
import DateUtils from "../../../../../../core/services/date-utils";

const ChatSection = ({
                         send,
                         sending,
                         chats,
                         createBubbleComponent,
                         messageComparator,
                         createTime,
                         createObject,
                     }) => {


    /**
     * For each of the files, sends them to the server api as a new message one by one.
     * @param images {File[]}
     */
    const sendFiles = (images) => {
        send(sendChatFiles(images, createObject) ?? []);
    }


    /**
     * Inserts the time bubbles into the chat of the user.
     * @return {*[]}
     * @private
     */
    const _insertTimeBubblesIntoChat = () => {
        /**
         * finds the date of the message based on their filled data
         * @param e
         * @return {string|*|Date}
         */
        const dateFinder = (e) => e.forwardedMsgInfo?.submitDateTime ?? e.submitDateTime ?? e.submittedDateTime;

        const sorted = [...chats?.sort(messageComparator) ?? []];
        const copy = [...sorted];
        if (copy.length) {
            const firstTime = dateFinder(copy[0]);
            const time = createTime(firstTime);
            sorted.splice(0, 0, time);
            for (let current = 0, after = 1; after < copy.length && current < copy.length - 1; current++, after++) {
                const afterDateTime = dateFinder(copy[after]);
                const currentDateTime = dateFinder(copy[current]);
                if (DateUtils.server(currentDateTime).isBefore((DateUtils.server(afterDateTime)), 'day')) {
                    const startIndex = sorted.findIndex((e) => DateUtils.server(dateFinder(e)).isSame(DateUtils.server(currentDateTime)));
                    if (startIndex === -1) continue;
                    const time = createTime(afterDateTime);
                    sorted.splice(startIndex + 1, 0, time);
                }
            }
        }
        return sorted;
    }


    /**
     * Inserts time slots between chats with different dates in terms of days and then creates the chat bubbles
     */
    const createChats = () => {
        if (!chats) return [];
        const _chats = _insertTimeBubblesIntoChat();
        return _chats?.map(createBubbleComponent)?.filter(e => e)?.map((e) => {
            return (
                <CSSTransition
                    key={e.key}
                    timeout={500}
                    classNames="item"
                >
                    {e.component}
                </CSSTransition>
            )
        });
    }

    return (
        <ChatDropZone
            disabled={sending}
            onFilesDrop={sendFiles}
        >
            <TransitionGroup className={'w-100 p-3 chat-section-scroller'} style={{overflowY: 'scroll'}}>
                {createChats() ?? []}
            </TransitionGroup>
        </ChatDropZone>
    );

}

export default ChatSection;
